import { GoBack } from "../../../components/Layout/GoBack";
import { BottomNav } from "../../../components/Nav/BottomNav";

const Plandetails = () => {
  return (
    <div>
      <div className="container px-4 pt-8 max-w-sm mx-auto relative  pb-24">
        <GoBack />

        <div className="mt-5"></div>
        <h2 className="font-body font-bold text-xl mt-3">About Our Plans</h2>

        <div className="space-y-3 mt-5">
          <div className="bg-gray-50 p-3 rounded-lg">
            <p className="text-sm font-body text-textGray font-semibold">
              1st Package: 6.7%
            </p>
            <p className="text-xs font-body text-textGray">
              Minimum: $15 | Maximum: $449
            </p>
          </div>

          <div className="bg-gray-50 p-3 rounded-lg">
            <p className="text-sm font-body text-textGray font-semibold">
              2nd Package: 8.6%
            </p>
            <p className="text-xs font-body text-textGray">
              Minimum: $450 | Maximum: $899
            </p>
          </div>

          <div className="bg-gray-50 p-3 rounded-lg">
            <p className="text-sm font-body text-textGray font-semibold">
              3rd Package: 11%
            </p>
            <p className="text-xs font-body text-textGray">
              Minimum: $900 | Maximum: $1,399
            </p>
          </div>

          <div className="bg-gray-50 p-3 rounded-lg">
            <p className="text-sm font-body text-textGray font-semibold">
              4th Package: 14%
            </p>
            <p className="text-xs font-body text-textGray">
              Minimum: $1,400 | Maximum: $2,499
            </p>
            <p className="text-xs font-body text-green-600 font-semibold">
              + Surprise package and money
            </p>
          </div>

          <div className="bg-gray-50 p-3 rounded-lg">
            <p className="text-sm font-body text-textGray font-semibold">
              5th Package: 19%
            </p>
            <p className="text-xs font-body text-textGray">
              Minimum: $2,500 | Maximum: $10,000
            </p>
            <p className="text-xs font-body text-green-600 font-semibold">
              + Free phone or bonus
            </p>
          </div>

          <div className="bg-gray-50 p-3 rounded-lg">
            <p className="text-sm font-body text-textGray font-semibold">
              6th Package: 28%
            </p>
            <p className="text-xs font-body text-textGray">
              Minimum: $10,000 | Maximum: $100,000+ (Unlimited)
            </p>
            <p className="text-xs font-body text-green-600 font-semibold">
              + Become MecGlobal agent with weekly salary
            </p>
          </div>
        </div>

        <div className="mt-5 bg-blue-50 p-4 rounded-lg">
          <p className="font-body text-sm font-semibold text-blue-800">
            MINIMUM DEPOSIT: $15
          </p>
          <p className="font-body text-sm font-semibold text-blue-800">
            MINIMUM WITHDRAWAL: $10
          </p>
        </div>

        <div className="mt-5 space-y-2">
          <p className="font-body text-sm text-textGray">
            DAILY EARNING AND WITHDRAWAL
          </p>
          <p className="font-body text-sm text-textGray">
            INVESTMENT DURATION: 24 HOURS
          </p>
          <p className="font-body text-sm text-textGray">
            WITHDRAWAL TIMING: 5 MINUTES
          </p>
          <p className="font-body text-sm text-textGray">WELCOME BONUS: $2</p>
          <p className="font-body text-sm text-textGray">
            THREE(3) LEVEL OF REFERRAL INCOME: 1ST LEVEL (10%),2ND LEVEL
            (5%),3RD LEVEL(3%)
          </p>
          <p className="font-body text-sm text-textGray">LIFE-TERM ASSURED</p>
          <p className="font-body text-sm text-textGray">TEAM LEADER BONUS</p>
          <p className="font-body text-sm text-textGray">FREE GIFTS</p>
          <p className="font-body text-sm text-textGray">
            FREE VISA FOR VACATION TO ANY COUNTRY
          </p>
          <p className="font-body text-sm text-textGray">NO WITHDRAWAL FEE</p>
          <p className="font-body text-sm text-textGray">
            24 HOURS ACTIVE SUPPORT AND WHATSAPP CUSTOMER CARE
          </p>
        </div>
      </div>
      <div className=" max-w-sm mx-auto w-full ">
        <BottomNav />
      </div>
    </div>
  );
};

export default Plandetails;
